import { createSelector } from 'reselect'
import { selectBase } from './selectBase'

export const selectIsAccountExpired = createSelector(selectBase, base => {
  return base.state === 'expired'
})
